<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>查看员工信息
    </div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :model="formdata" label-width="120px">
          <el-form-item label="头像">
            <img :src="formdata.pic" alt class="userImg-line"/>
          </el-form-item>
          <el-form-item label="工号">{{formdata.work_number}}</el-form-item>
          <el-form-item label="姓名">{{formdata.name}}</el-form-item>
          <el-form-item label="职位">{{formdata.position}}</el-form-item>
          <el-form-item label="名片展示手机号">{{formdata.phone}}</el-form-item>
          <!--<el-form-item label="邮箱">-</el-form-item>-->
          <el-form-item label="部门">
            <p v-for="item in formdata.department" :key="item.name">
              {{item.name}}
            </p>
          </el-form-item>
          <el-form-item label="是否内部人员">
            {{formdata.is_out == 1? '是':'否'}}
          </el-form-item>
          <el-form-item label="角色">{{role_name?role_name:'-'}}</el-form-item>
          <el-form-item label="绑定登录手机号">
            {{formdata.we_phone}}
          </el-form-item>
          <!-- <el-form-item label="绑定微信手机号">13696921359</el-form-item>
          <el-form-item label="个性标签">-</el-form-item>
          <el-form-item label="个性签名">-</el-form-item>
          <el-form-item label="微信">-</el-form-item>
          <el-form-item label="地址">-</el-form-item>
          <el-form-item label="语言介绍">-</el-form-item>
          <el-form-item label="照片">-</el-form-item>-->
          <el-form-item>
            <el-button type="primary" @click="employeeedit">编辑</el-button>
            <el-button @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "employeeDetail",

    data() {
      return {
        formdata: {
          work_number: "",
          pic: "",
          name: "",
          position: "",
          depart_id: "",
          department: "",
          phone: "",
          we_phone: '',
          role_id: '',
          is_out:''
        },
        employeeid: "",
        role_name: ''
      };
    },
    created() {
      this.employeeid = this.$route.query.employeeid;
      this.queryemployeedetail();
    },
    methods: {
      // 查询员工详情
      queryemployeedetail() {
        let params = {
          em_id: this.employeeid
        };
        this.axios
            .post(api.employee_detail, params)
            .then(response => {
              if (response.data.code == 0) {
                // this.formdata.work_number = response.data.info.work_number;
                // this.formdata.pic = response.data.info.pic;
                // this.formdata.name = response.data.info.name;
                // this.formdata.position = response.data.info.position;
                // this.formdata.depart_id = response.data.info.depart_id;
                // this.formdata.department = response.data.info.department;
                // this.formdata.phone = response.data.info.phone;
                for (let i in this.formdata) {
                  this.formdata[i] = response.data.info[i];
                }
                this.role_index()
              } else {
              }
            })
            .catch(response => {
            });

      },
      role_index() {
        this.axios
            .post(api.role_index, {page: 1})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.list) {
                  if (Number(response.data.list[i].id) === Number(this.formdata.role_id)) {
                    this.role_name = response.data.list[i].name
                  }
                }
              } else {
              }
            })
            .catch(response => {
            });
      },
      employeeedit() {
        this.$router.push({
          name: "employeeEdit",
          query: {employeeid: this.employeeid}
        });
      },
      goback() {
        this.$router.go(-1);
      }
    }
  };
</script>
